import state from './appState'
import mutations from './appMutations'
import actions from './appActions'
import getters from './appGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}